import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

type Variant = "success" | "pending" | "error" | "inactive" | "redirect";

const VARIANT_CLASSES: Record<Variant, string> = {
  success: "bg-green-100 text-green-800",
  pending: "bg-yellow-100 text-yellow-800",
  error: "bg-red-100 text-red-800",
  inactive: "bg-gray-100 text-gray-600",
  redirect: "bg-blue-100 text-blue-800",
};

const STATE_VARIANT_MAP: Record<string, Variant> = {
  ready: "success",
  active: "success",
  trial: "success",
  paid: "success",
  connected: "success",
  synced: "success",
  trial_active: "success",
  paid_active: "success",
  monthly: "success",
  yearly: "success",
  pending: "pending",
  degraded: "pending",
  unavailable: "error",
  pending_redirect: "redirect",
  blocked: "error",
  credential_invalid: "error",
  payment_required: "error",
  expired: "error",
  disconnected: "inactive",
  disabled: "inactive",
  deleted: "inactive",
  canceled: "inactive",
  unset: "inactive",
  confirmed_locked: "success",
  confirmed_mutable: "success",
};

interface StatusBadgeProps {
  state: string;
  className?: string;
  label?: string;
}

export function StatusBadge({ state, className, label }: StatusBadgeProps) {
  const { t } = useTranslation();
  const variant = STATE_VARIANT_MAP[state] ?? "inactive";
  const displayLabel = label ?? t(`states.${state}`, state);

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        VARIANT_CLASSES[variant],
        className,
      )}
    >
      {displayLabel}
    </span>
  );
}
